import { REPORT_QA_PREVIEW } from 'constants/routePaths';

import * as React from 'react';

import { WebAsset } from '@mui/icons-material';
import { ListItemIcon, ListItemText, MenuItem } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';
import formatPath from 'utils/formatPath';

interface Props {
  handleClose: () => void;
  report: reports.AllReportsQueryRow;
}

const ViewReportMenuItem: React.FC<Props> = ({ handleClose, report }) => {
  const { t } = useTranslation();
  const location = useLocation();

  return (
    <MenuItem
      onClick={handleClose}
      component={Link}
      to={{
        pathname: formatPath(REPORT_QA_PREVIEW, { reportId: report.reportId }),
        state: { from: `${location.pathname}${location.search}` },
      }}
    >
      <ListItemIcon>
        <WebAsset fontSize="small" />
      </ListItemIcon>
      <ListItemText primary={t('reportsQa.menu.viewReport')} />
    </MenuItem>
  );
};

export default ViewReportMenuItem;
